module.exports = __webpack_public_path__ + "static/media/logo-reporting.b4df0876.svg";